import { defaultEnterpriseFields } from '../api-client/settings-client'

export interface AccountState {
  initilised: boolean
  loading: boolean
  error: string
  details: EnterpriseBillingDetails
  accountOnboardingSections: OnboardingSection[] | null
}

export const initialState = {
  initilised: false,
  loading: false,
  error: '',
  details: defaultEnterpriseFields,
  accountOnboardingSections: null,
}

export const account = (
  state: AccountState = initialState,
  action: ReduxAction,
): AccountState => {
  switch (action.type) {
    case 'START_LOADING_ENTERPRISE_DETAILS': {
      return {
        ...state,
        initilised: true,
        loading: true,
      }
    }
    case 'LOAD_ENTERPRISE_DETAILS': {
      return {
        ...state,
        initilised: true,
        loading: false,
        details: {
          ...state.details,
          ...action.payload,
        },
      }
    }
    case 'LOAD_ENTERPRISE_DETAILS_ERROR': {
      return {
        ...state,
        initilised: true,
        loading: false,
        error: 'Error loading account details.',
      }
    }
    case 'UPDATE_ONBOARDING_SECTIONS': {
      return {
        ...state,
        accountOnboardingSections:
          action.payload.accountOnboardingProgress
            .accountOnboardingProgressList,
      }
    }

    default:
      return state
  }
}
